import { render } from "./ChangePriceDrawer.vue?vue&type=template&id=2cc31f37"
import script from "./ChangePriceDrawer.vue?vue&type=script&lang=js"
export * from "./ChangePriceDrawer.vue?vue&type=script&lang=js"

import "./ChangePriceDrawer.vue?vue&type=style&index=0&id=2cc31f37&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__